var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6075 13.4037L13.5971 13.3968L13.5864 13.3904L10.4866 11.5405C10.4865 11.5405 10.4864 11.5404 10.4864 11.5404C9.86787 11.1708 9.39014 10.3241 9.39014 9.60977V5.50977C9.39014 5.37591 9.50628 5.25977 9.64014 5.25977C9.77399 5.25977 9.89014 5.37591 9.89014 5.50977V9.60977C9.89014 9.90812 10.0067 10.2175 10.1443 10.4595C10.281 10.6998 10.487 10.9589 10.7461 11.1104L13.8439 12.9591L13.8439 12.9591L13.8482 12.9617C13.9566 13.0249 14.0042 13.1701 13.932 13.3013C13.8729 13.3911 13.7852 13.4298 13.7101 13.4298C13.6836 13.4298 13.6637 13.4267 13.6487 13.4226C13.6344 13.4187 13.6212 13.4129 13.6075 13.4037Z",
    stroke: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockActive);
export default __webpack_public_path__ + "static/media/clock-active.5127d238d210bf88945e445f6a27f918.svg";
export { ForwardRef as ReactComponent };